import {FC, ReactNode} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {LocalizedNumberFormat} from '@/components/common/LocalizedNumberFormat'
import {theme} from '@/theme/theme'
import {Currency} from '@/utils/currency'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type JurisdictionTooltipRowProps = {
  title: string
  number?: number
  note?: ReactNode
  numberType?: 'currency' | 'number'
  currency?: Currency
}

export const JurisdictionTooltipRow: FC<React.PropsWithChildren<JurisdictionTooltipRowProps>> = ({
  title,
  number,
  note,
  numberType = 'currency',
  currency,
}) => (
  <>
    <div className="item">
      <Text variant={TextVariant.caption} color="inherit">
        {title}
      </Text>
      {typeof number !== 'undefined' && (
        <Text variant={TextVariant.caption} color="inherit">
          {number > 0 ? (
            <LocalizedNumberFormat value={number} type={numberType} currency={currency} />
          ) : (
            note
          )}
        </Text>
      )}
    </div>

    <style jsx>{`
      .item {
        display: flex;
        justify-content: space-between;
        color: ${theme.palette.text.white};
      }

      @media ${TABLET_SCREENSIZE} {
        .item {
          color: ${theme.palette.text.default};
        }
      }
    `}</style>
  </>
)
